import React, {Component} from "react";
import {Alert, Row, Col, Modal, Button, Card, CardBody} from "reactstrap";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import paginationFactory, {PaginationListStandalone, PaginationProvider, SizePerPageDropdownStandalone} from "react-bootstrap-table2-paginator";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {Search,} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import NewModal from "./NewModal";
import DeleteModal from "./DeleteModal";
import {analyticalAccountsList} from "../../../store/companies/analyticalAccounts/actions";
import SelectModal from "../../../components/Common/SelectModal";
import {apiGetCompaniesSimpleList} from "../../../api/calls/companies";
import {get, patch} from "../../../api/api";
import {format} from "react-string-format";
import * as url from "../../../api/url";

class AnalyticalAccountsModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      analyticalAccountsData: [],
      loading: false,
      error: "",
      analyticalAccountData: null,
      newModal: false,
      deleteModal: false,
      supplierCompaniesModal: false,
    }
    this.refresh = this.refresh.bind(this)
    this.togSupplierCompanies = this.togSupplierCompanies.bind(this)
    this.togNew = this.togNew.bind(this)
    this.togDelete = this.togDelete.bind(this)
  }

  componentDidMount() {
    this.refresh()
  }

  refresh() {
    this.props.onAnalyticalAccountsList({history: this.props.history, companyId: this.props.companyData.id})
  }

  onClose = () => {
    this.props.togModal()
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      this.setState({
        analyticalAccountsData: this.props.response ? this.props.response.response : [],
        loading: this.props.loading,
        error: this.props.error
      });
    }
  }

  togSupplierCompanies(data = null) {
    this.setState(prevState => ({
      selectData: data,
      supplierCompaniesModal: !prevState.supplierCompaniesModal,
    }))
  }

  togNew(data = null, action) {
    this.setState(prevState => ({
      action: action,
      analyticalAccountData: data,
      newModal: !prevState.newModal,
    }))
  }

  togDelete(data = null) {
    this.setState(prevState => ({
      analyticalAccountData: data,
      deleteModal: !prevState.deleteModal,
    }))
  }

  apiGetSupplierCompaniesSelected = data => {
    return get(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS_DETAIL, this.props.companyData.id, this.state.selectData.id) + "supplier-companies/", this.props.history)
  }

  apiPatchSupplierCompaniesUpdate = data => {
    return patch(format(url.API_COMPANIES_ANALYTICAL_ACCOUNTS_DETAIL, this.props.companyData.id, this.state.selectData.id), this.props.history, {supplier_companies: data.selectedRows})
  }

  render() {
    const actionFormatter = (cell, row) => {
      return (<div>
        <Button color="info" className="me-2 mb-2" onClick={() => this.togSupplierCompanies({id: row.id})}>Supplier companies</Button>
        <Button color="success" className="me-2 mb-2" onClick={() => this.togNew({id: row.id, name: row.name, description: row.description}, "edit")}>Edit</Button>
        <Button color="danger" className="me-2 mb-2" onClick={() => this.togDelete({id: row.id, name: row.name})}>Delete</Button>
      </div>);
    }

    const columns = [{
      dataField: "id", text: "Id", sort: true,
    }, {
      dataField: "name", text: "Name", sort: true,
    }, {
      dataField: "description", text: "Description", sort: true,
    }, {
      dataField: "", text: "Actions", sort: true, formatter: actionFormatter,
    },];

    const defaultSorted = [{
      dataField: "id", order: "asc",
    },];

    const pageOptions = {
      sizePerPage: 10, totalSize: this.state.analyticalAccountsData.length, custom: true, sizePerPageList: [{
        text: '10', value: 10
      }, {
        text: '25', value: 25
      }, {
        text: '50', value: 50
      }]
    };

    const {SearchBar} = Search;

    function onColumnMatch({searchText, value, column, row}) {
      if (row.name.toLowerCase().includes(searchText) || row.description.toLowerCase().includes(searchText))
        return true
      return false
    }

    return (<React.Fragment>
      <Modal isOpen={true} toggle={this.onClose} size="xl">
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Analytical Accounts
          </h5>
          <button type="button" onClick={this.onClose} className="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <Card>
          <CardBody>
            <PaginationProvider
              pagination={paginationFactory(pageOptions)}
              keyField="id"
              columns={columns}
              data={this.state.analyticalAccountsData}
            >
              {({paginationProps, paginationTableProps}) => (<ToolkitProvider
                keyField="id"
                columns={columns}
                data={this.state.analyticalAccountsData}
                search={{onColumnMatch}}
              >
                {toolkitProps => (<React.Fragment>
                  <Row className="mb-2">
                    <Col md="8">
                      <div>
                        <Button color="primary" onClick={() => this.togNew({}, "new")}>
                          New
                        </Button>
                      </div>
                    </Col>
                    <Col md="4">
                      <div className="search-box me-2 mb-2 d-inline-block float-end">
                        <div className="position-relative">
                          <SearchBar {...toolkitProps.searchProps} placeholder="Filter"/>
                          <i className="bx bx-search-alt search-icon"/>
                        </div>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xl="12">
                      <div className="table-responsive">
                        <BootstrapTable
                          keyField={"id"}
                          responsive
                          bordered={false}
                          striped={false}
                          defaultSorted={defaultSorted}
                          classes={"table align-middle table-nowrap"}
                          headerWrapperClasses={"thead-light"}
                          {...toolkitProps.baseProps}
                          {...paginationTableProps}
                        />
                      </div>
                    </Col>
                  </Row>

                  <Row className="align-items-md-center mt-30">
                    <Col className="inner-custom-pagination d-flex">
                      <div className="d-inline">
                        <SizePerPageDropdownStandalone {...paginationProps}/>
                      </div>
                      <div className="text-md-right ms-auto">
                        <PaginationListStandalone {...paginationProps}/>
                      </div>
                    </Col>
                  </Row>
                </React.Fragment>)}
              </ToolkitProvider>)}
            </PaginationProvider>
            {this.state.loading && (<div className="d-flex justify-content-center">
              <div className="spinner-border text-primary" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>)}
            {this.state.error.length > 0 && (<div className="mt-3">
              <Alert color="danger" role="alert">
                {this.state.error}
              </Alert>
            </div>)}
          </CardBody>
        </Card>
      </Modal>
      {this.state.newModal &&
        <NewModal action={this.state.action}
                  togModal={this.togNew}
                  refreshParent={this.refresh}
                  analyticalAccountData={this.state.analyticalAccountData}
                  companyId={this.props.companyData.id}
                  history={this.props.history}/>}
      {this.state.deleteModal &&
        <DeleteModal togModal={this.togDelete}
                     refreshParent={this.refresh}
                     analyticalAccountData={this.state.analyticalAccountData}
                     companyId={this.props.companyData.id}
                     history={this.props.history}/>}
      {this.state.supplierCompaniesModal &&
        <SelectModal togModal={this.togSupplierCompanies}
                     refreshParent={this.refresh}
                     title="Select supplier companies"
                     apiList={apiGetCompaniesSimpleList}
                     apiSelected={this.apiGetSupplierCompaniesSelected}
                     apiUpdate={this.apiPatchSupplierCompaniesUpdate}
                     selectData={this.state.selectData}
                     history={this.props.history}/>}
    </React.Fragment>)
  }
}

AnalyticalAccountsModal.propTypes = {
  response: PropTypes.any,
  onAnalyticalAccountsList: PropTypes.func,
};

const mapStateToProps = ({AnalyticalAccounts}) => ({
  response: AnalyticalAccounts.responseList,
  loading: AnalyticalAccounts.loadingList,
  error: AnalyticalAccounts.errorList,
});

const mapDispatchToProps = dispatch => ({
  onAnalyticalAccountsList: data => dispatch(analyticalAccountsList(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(AnalyticalAccountsModal));